import { useEffect, useState } from 'react';
import 'bootstrap/dist/js/bootstrap.min.js';
import Modal from "react-bootstrap/Modal";
import gEventRouter from "../script/event_router.js";
import gUtilities from '../script/utilities';
import gSession from '../script/session';
import TableWidget from './TableWidget';

function JobDialog() {
    const [job, setJob] = useState(null);
    const [sdata, setSData] = useState(null);
    const [tdata, setTData] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
    const [titles, setTitles] = useState(null);
    const [columns, setColumns] = useState(null);
    const [content, setContent] = useState("status");
    const [description, setDescription] = useState("Select row for description");

    const showModal = (jdata) => {
        setIsOpen(true);
        setJob(jdata);

        selectContent("status");
    };

    const hideModal = () => {
        setIsOpen(false);
    };

    gEventRouter.register("JobWatchDialog.showModal", showModal);

    async function fetchData(job_id) {
        if (!content) {
            return;
        }

        let request = {
            service: "db.query",
            collection: "dcs_job",
            many: false,
            query: {
                job_id: job_id
            }
        };

        request.collection = content === "status" ? "dcs_job_status" : "dcs_timing";

        let response = await gSession.exchange(request);

        if (response.isError) {
            gUtilities.showError("Job Data", response.message);
            return;
        }

        if (content === "status") {
            updateStatus(response);
        } else {
            updateTiming(response);
        }
    }

    function toItem(prop, items, name) {
        let item = {
            name: name
        };

        let field;
        for (let i = 0; i < items.length; ++i) {
            field = "item" + (i + 1).toString();
            item[field] = items[i][prop];
        }

        return item;
    }

    function findLatestFlag(flags) {
        let list = [];
        let name;
        let names;

        try {
            names = Object.keys(flags);
            names.forEach(name => {
                list.push(flags[name]);
            });
        } catch (ex) {
            console.log("DEBUG: [flags.sort] 1", ex);
        }

        try {
            list.sort((l, r) => {
                if (l.time < r.time) {
                    return -1;
                }
                if (l.time > r.time) {
                    return 1;
                }

                return 0;
            });
        } catch (ex) {
            console.log("DEBUG: [flags.sort] 2", ex);
        }

        try {
            name = list[list.length - 1].name;
        } catch (ex) {
            console.log("DEBUG: [flags.sort] 3", ex);
        }

        return name;
    }

    function updateStatus(status) {
        let ititles = [
            "Name"
        ];

        let icolumns = [
            "name"
        ];

        let beams = status.beams;
        let computations = [];
        let computation;
        let upercent;

        for (let i = 0; i < beams.length; ++i) {
            let sn = (i + 1).toString();
            icolumns.push("item" + sn);
            ititles.push("Beam " + sn);
            beams[i].beam_flag = findLatestFlag(beams[i].flags);
            beams[i].compute_flag = findLatestFlag(beams[i].computation.flags);

            computation = beams[i].computation;
            upercent = 100.0 * computation.uncertainty;
            computation.uncertainty = upercent.toFixed(1);
            computations.push(computation);
        }

        let items = [];
        items.push(toItem("name", beams, "Name"));
        items.push(toItem("state", beams, "State"));
        items.push(toItem("outcome", beams, "Outcome"));
        items.push(toItem("beam_flag", beams, "Beam Flag"));
        items.push(toItem("compute_flag", beams, "Compute Flag"));
        items.push(toItem("total_duration", computations, "Compute Duration"));
        items.push(toItem("progress", computations, "Progress %"));
        items.push(toItem("batch", computations, "Current Batch"));
        items.push(toItem("estimated_batches", computations, "Estimated Batches"));
        items.push(toItem("uncertainty", computations, "Uncertainty %"));
        items.push(toItem("collision_status", computations, "Collision Status"));
        items.push(toItem("convergence_status", computations, "Convergence Status"));

        setColumns(icolumns);
        setTitles(ititles)
        setSData(items);
    }

    function toDurationString(ms) {
        let d;
        let u;

        if (ms > 60000) {
            d = (ms / 60000.0).toFixed(2);
            u = "min";
        } else if (ms > 1000) {
            d = (ms / 1000.0).toFixed(2);
            u = "sec";
        } else {
            d = ms.toString();
            u = "ms";
        }

        return [d, u];
    }

    function formatTimes(event) {
        let du;

        du = toDurationString(event.from_previous_ms);
        event.from_previous_ms = du[0];
        event.up = du[1];

        du = toDurationString(event.from_begin_ms);;
        event.from_begin_ms = du[0];
        event.ub = du[1];

        event.time = event.time.substr(11);
    }

    let tTitles = [
        "Flag",
        "Delta",
        "U",
        "Total",
        "U",
        "Time"
    ];

    let tColumns = [
        "name",
        "from_previous_ms",
        "up",
        "from_begin_ms",
        "ub",
        "time"
    ];

    function updateTiming(timing) {
        for (let event of timing.events) {
            formatTimes(event);
        }

        setTData(timing.events);
    }

    function scheduleUpdate() {
        let id = setTimeout(() => {
            try {
                if (job) {
                    fetchData(job.job_id);
                }
            } catch (ex) {
                console.log("ERROR: [EXCEPTION] job status - ", ex);
            }
        }, 200);

        return id;
    }

    function allowStatus() {
        return sdata && content === "status";
    }

    function allowTiming() {
        return tdata && content === "timing";
    }

    function onSelectEvent(event) {
        let desc;

        if (event.name === "created") {
            desc = "Calculation requested by planning";
        } else if (event.name === "uploaded") {
            desc = "Planning files sent to cloud";
        } else if (event.name === "production") {
            desc = "Monte Carlo scripts generated";
        } else if (event.name === "reserved") {
            desc = "Cluster nodes online";
        } else if (event.name === "version") {
            desc = "Initial output from Monte Carlo engine";
        } else if (event.name === "batches") {
            desc = "Data loaded; particle transport begins";
        } else if (event.name === "exited") {
            desc = "Particle transport completed";
        } else if (event.name === "processing") {
            desc = "RTDOSE files generated";
        } else if (event.name === "dose") {
            desc = "RTDOSE files sent to cloud; client notified";
        } else if (event.name === "downloaded") {
            desc = "Completed; client signals planning";
        } else {
            desc = "No description available";
        }

        setDescription(desc);
    }

    function selectContent(name) {
        setTData(null);
        setSData(null);

        setContent(name);
    }

    function onClose() {
        setTData(null);
        setSData(null);

        setContent(null);

        hideModal();
    }

    useEffect(() => {
        let timer_id = scheduleUpdate();

        // cleanup function: stop updates.
        return () => {
            if (isOpen) {
                clearTimeout(timer_id);
            }
        };
    }, [isOpen, sdata, tdata]);

    return (
        <div>
            <Modal show={isOpen}>
                <div className="modal-content">
                    <div className="modal-header">
                        <h3 className="modal-title">Job Status And Timing</h3>
                    </div>
                    <div>
                        <ul className="nav nav-tabs">
                            <li className="nav-item">
                                <a className="nav-link active" data-bs-toggle="tab" href="#w_JobStatusContentDiv"
                                    onClick={() => selectContent("status")}>Status</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" data-bs-toggle="tab" href="#w_JobStatusContentDiv"
                                    onClick={() => selectContent("timing")}>Timing</a>
                            </li>
                        </ul>
                    </div>
                    <div className="modal-body">
                        <div id="w_DocumentationDiv" className="tab-content">
                            <div className="tab-pane fade active show" id="w_JobStatusContentDiv">
                                {allowStatus() &&
                                    <div className="form-group">
                                        <TableWidget name="StatusTable" data={sdata} columns={columns} titles={titles} />
                                    </div>
                                }
                                {allowTiming() &&
                                    <div className="form-group">
                                        <TableWidget name="TimingTable" data={tdata} columns={tColumns} titles={tTitles} cellNoWrap={true} rowSelectCallback={onSelectEvent} />
                                        <h5>{description}</h5>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={onClose}>Close</button>
                    </div>
                </div>
            </Modal>
        </div>
    )
}

export default JobDialog;